'use strict';

angular.module('AcaApp').factory('UtilsService', [
  'PASSWORD_MESSAGES',
  '$window',
  function(PASSWORD_MESSAGES, $window){
    return {
      /**
       * Validates password and confirmation
       * @param  {[string]} pass1 [password]
       * @param  {[string]} pass2 [confirmation]
       * @return {[object]}       [result object]
       */
      validatePassword: function(pass1, pass2){
        //Regex: at least one uppercase and one lowercase, length>=8, and at least one special char
        var result = {'value': false, 'msg': ''};
        var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
        var reSpecialChars = /[\^\~\!\@\#\(\)\_\=\{\}\|\:\;\,\.\?\^\+\$\`\*\[\]\-]+/;
        var reRepeated = /(.)\1\1/;
        if(pass1 === '' || pass2 === ''){
          result.msg = PASSWORD_MESSAGES.PASSREQUIREMENTS;
          return result;
        }
        if(pass1 !== pass2){
          result.msg = PASSWORD_MESSAGES.PASSDONTMATCH;
          return result;
        }
        if(reRepeated.test(pass1)){
          result.msg = PASSWORD_MESSAGES.PASSREPETING;
          return result;
        }
        if(!re.test(pass1)){
          result.msg = PASSWORD_MESSAGES.PASSREQUIREMENTS;
          return result;
        }
        if(!reSpecialChars.test(pass1)){
          result.msg = PASSWORD_MESSAGES.PASSREQUIREMENTS;
          return result;
        }
        else{
          result.value = true;
          return result;
        }
      },
      checkPasswordContent: function(pass, data){
        var re = new RegExp(this.escapeRegExp(data));
        return re.test(pass);
      },
      escapeRegExp: function(str){
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      },
      /**
      *Convert to unix timestamp
      *For example:
      *date: 05/08/2015 14:11:39
      *ts: 1438783899
      */
      getUnixTimestamp: function(date){
        var d = new Date(date);
        var month = String((d.getMonth() + 1));
        var day = String(d.getDate());
        var year = d.getFullYear();
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        if(month.length < 2){
          month = '0' + month;
        }
        if(day.length < 2){
          day = '0' + day;
        }
        var resultDate = [month, day, year].join('/') + ' ' + strTime;
        return resultDate;
      },
      getCScriptDateFormat: function(date){
        //jscs:disable maximumLineLength
        var dateRegex = /^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/;
        var dateString = '';
        if(dateRegex.test(date)){
          dateString = date.split('/');
        }
        else{
          dateString = '01/02/1900'.split('/');
        }
        var d = new Date(dateString[2], dateString[0] - 1, dateString[1]);
        //jscs:disable validateNewlineAfterArrayElements
        var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var cScriptDate = day[d.getDay()] + ', ' + d.getUTCDate() + ' ' + month[d.getMonth()] + ' ' + d.getFullYear() + ' 00:00:00 GMT';
        return cScriptDate;
      },
      isInternetExplorer: function(version){
        /* jscs:disable disallowImplicitTypeConversion */
        if(version === '10'){
          return new RegExp('msie' + (!isNaN(version) ? ('\\s' + version) : ''), 'i').test(navigator.userAgent);
        }
        else{
          if(version === '11'){
            return !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
          }
          else{
            return navigator.userAgent.toLowerCase().match(/msie/);
          }
        }
      },
      getCurrencyFormat: function(value, n, x){
        if(value === ''){
          return '';
        }
        value = parseFloat(value.replace(/,/g, ''));
        var regexVal = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
        return value.toFixed(Math.max(0, ~~n)).replace(new RegExp(regexVal, 'g'), '$&,');
      },
      convertToKB: function(files){
        if(files.length > 0){
          _.each(files, function(element){
            element.filesize = (element.filesize / 1024).toFixed(2);
          });
        }
        return files;
      },
      errorMessageValidationForString: function(message){
        message = message.replace(/\\n/g,'\n');
        if(message.indexOf('\n') > -1){
          return message.split('\n');
        }
        else{
          return [message];
        }
      },
      errorMessageValidationForArray: function(array){
        if(array.length > 0){
          _.each(array, function(element){
            if(element.ErrorMessage !== undefined){
              element.ErrorMessage = element.ErrorMessage.split('\n');
            }
          });

          return array;
        }
      },
      getStates: function(){
        var states = [
          {key: 'AL', value: 'Alabama'},
          {key: 'AK', value: 'Alaska'},
          {key: 'AZ', value: 'Arizona'},
          {key: 'AR', value: 'Arkansas'},
          {key: 'CA', value: 'California'},
          {key: 'CO', value: 'Colorado'},
          {key: 'CT', value: 'Connecticut'},
          {key: 'DE', value: 'Delaware'},
          {key: 'DC', value: 'District Of Columbia'},
          {key: 'FL', value: 'Florida'},
          {key: 'GA', value: 'Georgia'},
          {key: 'HI', value: 'Hawaii'},
          {key: 'ID', value: 'Idaho'},
          {key: 'IL', value: 'Illinois'},
          {key: 'IN', value: 'Indiana'},
          {key: 'IA', value: 'Iowa'},
          {key: 'KS', value: 'Kansas'},
          {key: 'KY', value: 'Kentucky'},
          {key: 'ME', value: 'Maine'},
          {key: 'MD', value: 'Maryland'},
          {key: 'MA', value: 'Massachusetts'},
          {key: 'MI', value: 'Michigan'},
          {key: 'MN', value: 'Minnesota'},
          {key: 'MS', value: 'Mississippi'},
          {key: 'MO', value: 'Missouri'},
          {key: 'MT', value: 'Montana'},
          {key: 'NE', value: 'Nebraska'},
          {key: 'NV', value: 'Nevada'},
          {key: 'NH', value: 'New Hampshire'},
          {key: 'NJ', value: 'New Jersey'},
          {key: 'NM', value: 'New Mexico'},
          {key: 'NY', value: 'New York'},
          {key: 'NC', value: 'North Carolina'},
          {key: 'ND', value: 'North Dakota'},
          {key: 'OH', value: 'Ohio'},
          {key: 'OK', value: 'Oklahoma'},
          {key: 'OR', value: 'Oregon'},
          {key: 'PA', value: 'Pennsylvania'},
          {key: 'RI', value: 'Rhode Island'},
          {key: 'SC', value: 'South Carolina'},
          {key: 'SD', value: 'South Dakota'},
          {key: 'TN', value: 'Tennessee'},
          {key: 'TX', value: 'Texas'},
          {key: 'UT', value: 'Utah'},
          {key: 'VT', value: 'Vermont'},
          {key: 'VA', value: 'Virginia'},
          {key: 'WA', value: 'Washington'},
          {key: 'WV', value: 'West Virginia'},
          {key: 'WI', value: 'Wisconsin'},
          {key: 'WY', value: 'Wyoming'}
        ];
        return states;
      },
      addDatepicker: function(component){
        /* istanbul ignore next */
        $timeout(
          function(){
            $(component).datetimepicker({
              timepicker: false,
              format: FORMATS.DATEFORMAT
            });
          }
        );
      },
      checkValidDate: function(date){
        if(date !== undefined && date !== '') {
          return /^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/.test(date);
        }
      },
      checkTenCharacters: function(value){
        return !(value.length < 10 || value.length > 10);
      },
      checkNineCharacters: function(value){
        return !(value.length < 9);
      },
      checkIsNumber: function(number){
        return !(isNaN(number));
      },
      checkMostDateCurrent: function(date){
        var inputDate = new Date(date);
        var todaysDate = new Date();
        return inputDate.setHours(0, 0, 0, 0) <= todaysDate.setHours(0, 0, 0, 0);
      },
      checkCharacter: function(evt){
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        if (key === 8){
          return;//bug FF
        }
        key = String.fromCharCode(key);
        var regex = /[0-9]/;
        if(!regex.test(key)){
          theEvent.returnValue = false;
          if(theEvent.preventDefault){
            theEvent.preventDefault();
          }
        }
      },
      checkAlphaCharacter: function(evt){
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        var regex = /[a-zA-Z- ]/;
        if(!regex.test(key)){
          theEvent.returnValue = false;
          if(theEvent.preventDefault){
            theEvent.preventDefault();
          }
        }
      },
      checkAlphaNumSpecCharacter: function(evt){
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        var regex = /[a-zA-Z0-9./' -]/;
        if(!regex.test(key)){
          theEvent.returnValue = false;
          if(theEvent.preventDefault){
            theEvent.preventDefault();
          }
        }
      },
      splitFilename: function(result){
        var index = result.lastIndexOf('~');
        return result.slice(index + 1, result.length);
      },
      splitFilenameXmit: function(result){
        return result.split('~');
      },
      reformatDateString: function(date){
        var dateArray;
        var months = {
          Jan: 'January', Feb: 'February', Mar: 'March', Apr: 'April', May: 'May', Jun: 'June',
          Jul: 'July', Aug: 'August', Sep: 'September', Oct: 'October', Nov: 'November', Dec: 'December'
        };
        dateArray = (date !== '') ? date.split(' ') : '';
        if(dateArray !== ''){
          return months[dateArray[2]] + ' ' + dateArray[1] + ', ' + dateArray[3];
        }
        return '';
      },
      isNumber: function(inputValue){
        var numbers = /^[0-9]+$/;
        return inputValue.match(numbers);
      },
      reformatDateTimeString: function(date){
        var dateArray;
        var months = {
          Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
          Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
        };
        dateArray = (date !== '') ? date.split(' ') : '';
        if(dateArray !== ''){
          return months[dateArray[2]] + '/' + dateArray[1] + '/' + dateArray[3];
        }
        return '';
      },
      checkAvoidNullification: function(data){
        return (data !== undefined) ? data : -2147483648;
      },
      addAsteriskForRequiredField: function(metadata){
        if(metadata.data_title === 'PLANSTARTMONTH' && $window.sessionStorage.taxYear < 2020) metadata.validation = false;
        return metadata.data_title + ((metadata.validation !== undefined && metadata.validation.required === true) ? ' *' : '');
      },
      getFchar: function(arg){
        var array = arg.split('\n');
        var id = array[0].split(':')[1].trim();
        var fchar = array[1].split(' ')[0].trim();
        var fc = fchar === 'Participant'
          ? '1'
          : fchar === '1095-B'
          ? 'X5B'
          : fchar === '1095-C'
          ? 'X5C'
          : fchar === 'Employer'
          ? '0'
          : '';

        return {
          importId: parseInt(id),
          fchar: fc
        };
      },
      getStmtRun: function(arg){
        var array = arg.split('\n');
        var id = array[0].split(':')[1].trim();
        return {
          stmtRun: parseInt(id)
        };
      },
      getXmitRun: function(arg){
        var array = arg.split('\n');
        var id = array[0].split(':')[1].trim();
        return {
          xmitRun: parseInt(id)
        };
      },
      getXmitRunIds: function(arg){
        var array = arg.split('\n');
        var id = array[0].split(':')[1].trim();
        return parseInt(id);
      },
      getTaxYear: function(){
        return 'TY' + $window.sessionStorage.taxYear;
      },
      firstLetterUppercase: function(text){
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
      getFileNameFromLrj: function(data){
        var dataArray = data.map(function(el){
          return el.match(/^FileName\: /);
        }).filter(function(e){
          return e !== null;
        });
        var printFileName = dataArray[0]['input'].split('\n');
        return this.splitFilename(printFileName[0].replace('FileName: ', ''));
      },
      compareNumbers: function(a, b){
        return a - b;
      },
      checkContactPhone: function(value){
        return !(value.length < 10);
      },
      checkContact: function(value){
        return !((value.match(/ /g)||[]).length < 1);
      },
       /**
       * Converts comma separated key=value list to object
       * @param {*} rawString
       */
      csvStringToObject: function(rawString) {
        var result = rawString.split(',').reduce(function(pre, opt) {
          var keyValue = opt.split('=');

          pre[keyValue[0]] = keyValue[1];

          return (pre);
        }, {});

        return result;
      }
    };
  }
]);
